import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  NbLayoutDirection,
  NbLayoutDirectionService,
  NbMediaBreakpointsService,
  NbMenuService,
  NbSidebarService,
  NbThemeService,
} from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject, Subscription  } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { InternalService } from '../../../services/internal.service';
import { ApiService } from '../../../services/api.service';
import { UserService } from '../../../@core/mock/users.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Router } from '@angular/router';


@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;

  recordsSub: Subscription;

  

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  private userMenu = [
    { title: this.translate.instant('Profile'), id: 'Profile', icon: 'person-outline', link: `/pages/profile/0`, },
    { title: 'LogOut', id: 'LogOut', icon: 'log-out-outline' }
  ];

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    public userInfo: UserService,
    private layoutService: LayoutService,
    public translate: TranslateService,
    public internalService: InternalService,
    public directionService: NbLayoutDirectionService,
    private breakpointService: NbMediaBreakpointsService,
    public apiService: ApiService,
    private router: Router,
    public oidcSecurityService: OidcSecurityService) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  // recordsSub = this.menuService.onItemClick().subscribe(( event ) => {
  //   this.onItemSelection(event.item.title);
  // })

  onItemSelection(title) {
    if ( title === 'LogOut') {
      console.log('q');
    }
  }

  ngOnInit() {
      if(localStorage.getItem('theme')){
        this.changeTheme(localStorage.getItem('theme')) 
      }
      
      // this.userMenu = this.translate.instant('LogOut')
     
    this.menuService.onItemClick().subscribe((event) => {
        this.onItemSelection(event.item.title)

        if (event.item.title === 'LogOut') {

          const url = this.oidcSecurityService.getEndSessionUrl();
          this.oidcSecurityService.logoffLocal();
          window.location.assign(url);
          // this.oidcSecurityService.logoff((url: 'https://mac.medis.land/account/logout') => any);
          this.oidcSecurityService.logoff((url: 'https://mac.medis.land/account/logout') => '');
          
        }
      });
    this.currentTheme = this.themeService.currentTheme;
    // this.userService.getUsers()
    //   .pipe(takeUntil(this.destroy$))
    //   // .subscribe((users: any) => this.user = users.nick);
    //   .subscribe((users: any) => {
    //     // console.log(users);
    //     this.user = this.userInfo.user
    //   });
    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
    localStorage.setItem('theme', themeName)
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  changeLang() {
    const oppositeDirection = this.directionService.isRtl() ? NbLayoutDirection.LTR : NbLayoutDirection.RTL;
    this.directionService.setDirection(oppositeDirection);
    oppositeDirection === 'ltr' ? this.internalService.changeLang('en-us', 1) :
      this.internalService.changeLang('fa-ir', 1);
  }



  // changeLang2() {
  //   const body = document.getElementsByTagName('BODY')[0] as HTMLElement;
  //   const content = document.getElementsByClassName('content')[0] as HTMLElement;
  //   const sidebar = document.getElementsByClassName('menu-sidebar')[0] as HTMLElement;

  //   const expansionIndicator = document.getElementsByClassName('expansion-indicator') as HTMLCollectionOf<HTMLElement>;
  //   const nbIcon = document.getElementsByTagName('nb-icon') as HTMLCollectionOf<HTMLElement>;

  //   if (body.style.direction === 'rtl') {
  //     body.style.direction = 'ltr';
  //     sidebar.style.textAlign = 'left';
  //     content.style.textAlign = 'left';
  //     for (const item of expansionIndicator) {
  //       item.style.left = 'unset';
  //       item.style.right = '1rem';
  //     }
  //     for (const item of nbIcon) {
  //       item.style.right = 'unset';
  //       item.style.left = '0.41rem';

  //     }
  //   } else {
  //     body.style.direction = 'rtl';
  //     sidebar.style.textAlign = 'right';
  //     content.style.textAlign = 'right';
  //     for (const item of expansionIndicator) {
  //       item.style.right = 'unset';
  //       item.style.left = '1rem';
  //     }
  //     for (const item of nbIcon) {
  //       item.style.left = 'unset';
  //       item.style.right = '0.41rem';
  //     }
  //   }
  // }
}
